const Footer = () => {
    return (
        <div className="footer">
            <p>for Serenidad</p>
            <p>1951-2022</p>
        </div>
    );
}

export default Footer;